import R from 'ramda';
import sanitize from 'sanitize-filename';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import { Button, Form, OverlayTrigger, Popover } from 'react-bootstrap';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import TeamMembers from './TeamMembers';
import AgreementTextWorkForHire from './AgreementTextWorkForHire';
import AgreementTextPremiumSplit from './AgreementTextPremiumSplit';
import AgreementTextProducer from './AgreementTextProducer';
import ShortContent from '../ContractBlock/ShortContent';
import SpinnerComponent from '../SpinnerComponent';
import { COSYND_PDF_URL } from '../../constants';
import getOtherAcceptedRedlined from '../Deals/DealEditPages/helpers/getOtherAcceptedRedlined';

const popoverFocus = (
  <Popover id="popover-trigger-focus" title="Cosynd Support">
    <strong>
      Congratulations on completing your agreement! Now, you can register this
      content with the U.S. Copyright Office. Registration is critical and
      grants you immediate rights and benefits, such as the ability to file a
      lawsuit. Click here to start now.
    </strong>
  </Popover>
);

class AgreementDetail extends Component {
  constructor() {
    super();
    this.state = {
      blocks: [],
      works: [],
      showAgreementText: false,
      members: [],
    };
  }

  componentWillMount() {
    const { params, agreement } = this.props;

    if (params && params.agreementId) {
      this.props.loadAgreement(params.agreementId);
      this.props.loadBlockContents(params.agreementId);
    } else if (agreement) {
      this.props.loadAgreement(agreement.id);
      this.props.loadBlockContents(agreement.id);
      this.props.loadMembers(agreement.team);
    }
    this.props.assignAttribute('memberPublishers', []);
  }

  componentWillReceiveProps(nextProps) {
    const { status, agreement, contractBlocks, agreementContractBlocks } =
      nextProps;

    if (this.props.status !== status) {
      if (status === actionTypes.AGREEMENT_DELETE_SUCCESS) {
        this.props.router.push(`/agreements`);
      }

      if (status === actionTypes.AGREEMENT_GET_SUCCESS && agreement) {
        let deals = agreement.deals || [];
        deals = R.filter((deal) => deal.progress === 100, deals);
        if (deals.length) {
          this.props.loadDealUsers(deals[deals.length - 1].id);
          this.props.loadDealInvites(deals[deals.length - 1].id);
        }
        this.props.loadMembers(agreement.team);
      } else if (
        status === actionTypes.AGREEMENT_CONTRACT_BLOCKS_GET_SUCCESS &&
        contractBlocks &&
        agreementContractBlocks
      ) {
        const blocks = [];

        contractBlocks.forEach((block, i) => {
          const index = R.findIndex(R.propEq('contract_block', block.id))(
            agreementContractBlocks
          );
          if (index !== -1) {
            block.content = agreementContractBlocks[index].content;
            block.options = JSON.parse(agreementContractBlocks[index].options);
          }
          blocks.push(block);
        });

        this.setState({ blocks });
      }
    }

    let works = agreement ? agreement.works || [] : [];

    if (works.length && !R.equals(works, this.state.works)) {
      works = R.sortBy(R.prop('date_created'), works);
      this.setState({ works });
    }
  }

  checkSentenceAccepted(sentenceChange, userId) {
    const { invites, dealUsers } = this.props;
    const accepts = sentenceChange.accepts || [];

    let userIds = R.pluck('invitee', invites);
    const owner = R.find(R.propEq('type', 'owner'))(dealUsers);
    if (owner) {
      userIds.push(owner.user);
    }

    return userIds.every(
      (id) => id && (id === userId || accepts.indexOf(id) !== -1)
    );
  }

  getAgreementSentence(section) {
    const { agreement } = this.props;
    let acceptedStatus = false;

    if (agreement) {
      const sentences = agreement.sentences || [];
      const acceptedSentences = sentences.filter(
        (item) =>
          item.section.replace(/\s/g, '') === section ||
          item.section.replace(/\s/g, '') === `${section}title`
      );
      acceptedStatus = acceptedSentences.length > 0;
    }
    return acceptedStatus;
  }

  renderContractBlocks() {
    const { blocks } = this.state;
    const { agreement } = this.props;

    if (agreement.type !== 'split' && blocks.length) {
      return blocks.map((block, i) => {
        const acceptedStatus = this.getAgreementSentence(
          block.name.replace(/\s/g, '')
        );

        if (block.name !== 'Licensing Permissions') {
          return [
            <ShortContent key="0" block={block} blocks={blocks} />,

            acceptedStatus ? (
              <tr key="1">
                <td />
                <td className="change-redline-request">
                  <FontAwesome name="exclamation-triangle" />
                  <div className="change-content">
                    <span className="text-red">
                      This section has been redlined
                    </span>
                  </div>
                </td>
              </tr>
            ) : null,
          ];
        } else {
          return null;
        }
      });
    }
    return null;
  }

  handleNext() {
    this.props.router.push('/create/agreement-detail-split-update');
  }

  handlePrev() {
    if (this.props.route.type === 'create') {
      this.props.router.push('/create/select-agreement');
    } else {
      this.props.router.push('/agreements');
    }
  }

  handleDelete() {
    if (
      confirm(
        'Are you sure you want to delete this agreement? You and your collaborators will lose access to this agreement if you do.'
      )
    ) {
      this.props.deleteAgreement(this.props.params.agreementId);
    }
  }

  handleShowAgreementText(e) {
    e.preventDefault();
    this.setState({ showAgreementText: !this.state.showAgreementText });
  }

  handleAgreementDownload = (e) => {
    e.preventDefault();
    const { agreement } = this.props;

    if (agreement) {
      // Get agreement content
      findDOMNode(this.refs.printContainer).innerHTML = findDOMNode(
        this.refs.agreementTerms
      ).innerHTML;
      const notAccepted = document.querySelectorAll(
        '.pdf-wrapper .work-not-accepted'
      );
      if (notAccepted) {
        Array.prototype.forEach.call(notAccepted, function (node) {
          node.parentNode.removeChild(node);
        });
      }

      // Get Agreement text contents
      var agreementText = findDOMNode(this.refs.printContainer).innerHTML;

      // Sanitize filename string
      var agreementFilename =
        sanitize(agreement.name)
          .toLowerCase()
          .replace('.', '_')
          .replace('(', '_')
          .replace(')', '_')
          .split(' ')
          .join('_') + '.pdf';

      // Populate form fields
      findDOMNode(this.refs.agreementFilename).value = agreementFilename;
      findDOMNode(this.refs.agreementTextContents).value = agreementText;

      // Submit form
      findDOMNode(this.refs.agreementToPDF).action = COSYND_PDF_URL;
      findDOMNode(this.refs.agreementToPDF).submit();

      // findDOMNode(this.refs.agreementToPDF).action = '';
      findDOMNode(this.refs.printContainer).innerHTML = '';
    }

    return false;
  };

  render() {
    const { agreement, route } = this.props;

    const acceptedOtherStatus = getOtherAcceptedRedlined(
      this.state.blocks,
      agreement
    );

    return (
      <div className="agreement-detail">
        <Heading text="Agreement Details" />

        {agreement ? (
          <div className="content">
            <h3>{agreement.name}</h3>
            {route.type === 'create' && (
              <div>
                <p className="text-gray">
                  Before you can add this copyright to your agreement, review
                  the actual agreement text and terms below to be sure that is
                  the correct one.
                </p>
                <p className="text-gray">
                  You will have a chance to adjust the splits and roles in the
                  next section.
                </p>
              </div>
            )}

            {agreement.type !== 'workforhire' &&
              agreement.type !== 'producer' &&
              this.state.works &&
              this.state.works.length > 0 && (
                <TeamMembers
                  type="detail"
                  agreeType={agreement.type}
                  teamId={agreement.team}
                  work={this.state.works[0]}
                  hideValue={true}
                  onEdit={() => {}}
                />
              )}

            <div className="terms-summary">
              <div className="subheading">Terms summary</div>
              <p className="text-gray">
                Note: If an attorney has redlined this agreement, the points
                below may have changed and may not be applicable. Carefully read
                and review your entire agreement before proceeding.
              </p>
              <br />
              <table>
                <tbody>{this.renderContractBlocks()}</tbody>
              </table>

              {acceptedOtherStatus && (
                <div className="other-redline change-redline-request">
                  <FontAwesome name="exclamation-triangle" />
                  <div className="change-content">
                    <span className="text-red">
                      Other parts of this agreement have been redlined and
                      should be reviewed.
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="agreement-terms agreement-finalized-terms">
              <div className="agreement-finalized-terms-header">
                <h1>
                  <a onClick={(e) => this.handleShowAgreementText(e)}>
                    {this.state.showAgreementText ? (
                      <FontAwesome name="caret-up" />
                    ) : (
                      <FontAwesome name="caret-down" />
                    )}
                    {'  '}View Full Agreement
                  </a>
                </h1>

                <OverlayTrigger
                  trigger={['hover', 'focus']}
                  placement="right"
                  overlay={popoverFocus}
                >
                  <h1>
                    <a href="/copyright-reg">
                      Register with the Copyright Office
                    </a>
                  </h1>
                </OverlayTrigger>
              </div>
              <div ref="agreementTerms">
                {this.state.showAgreementText &&
                  (agreement.type === 'workforhire' ? (
                    <AgreementTextWorkForHire
                      works={this.state.works}
                      type="agreement-detail"
                    />
                  ) : agreement.type === 'producer' ? (
                    <AgreementTextProducer
                      works={this.state.works}
                      type="agreement-detail"
                    />
                  ) : (
                    <AgreementTextPremiumSplit
                      works={this.state.works}
                      type="agreement-detail"
                    />
                  ))}
              </div>
            </div>

            {this.state.showAgreementText && (
              <Form
                method="post"
                ref="agreementToPDF"
                onSubmit={this.handleAgreementDownload}
              >
                <input
                  type="hidden"
                  ref="agreementFilename"
                  name="agreement_filename"
                  value="agreement.pdf"
                />
                <input
                  type="hidden"
                  ref="agreementTextContents"
                  name="agreement_text"
                  value=""
                />
                <Button bsStyle="link" type="submit">
                  Download
                </Button>
              </Form>
            )}
          </div>
        ) : (
          <SpinnerComponent size={100} />
        )}

        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handlePrev()} />
          {route.type === 'create' ? (
            <NavButtons direction="next" next={() => this.handleNext()} />
          ) : (
            <Button
              bsStyle="link"
              className="btn-delete"
              onClick={() => this.handleDelete()}
            >
              {agreement ? 'delete' : ''}
            </Button>
          )}
        </div>

        <div className="pdf-wrapper">
          <div ref="printContainer" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.create.fields,
  agreement: state.agreements.selectedAgreement,
  members: state.users.members,
  contractBlocks: state.global.contractBlocks,
  agreementContractBlocks: state.agreements.contractBlocks,
  status: state.agreements.status,
  error: state.agreements.error,
  dealUsers: state.dealUsers.dealUsers,
  invites: state.invites.invites,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadAgreement: (id) => {
    dispatch(actions.getAgreement(id));
  },
  loadBlockContents: (agreementId) => {
    dispatch(actions.getAgreementContractBlockContents(agreementId));
  },
  deleteAgreement: (id) => {
    dispatch(actions.deleteAgreement(id));
  },
  updateOwnership: (ownership) => {
    dispatch(actions.updateMemberOwnership(ownership));
  },
  setWorkOwnerships: (workOwnerships) => {
    dispatch(actions.setWorkOwnerships(workOwnerships));
  },
  loadDealUsers: (dealId) => {
    dispatch(actions.getDealUsers(dealId));
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignAttribute(field, attribute));
  },
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
  loadDealInvites: (dealId) => {
    dispatch(actions.getInvites(dealId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AgreementDetail);



// WEBPACK FOOTER //
// src/components/Agreements/AgreementDetail.jsx